import {FormationSearchCriteria} from "./../../../../../common/resources/resources";

import {FormationDto, IFormationWebServiceClient} from "@resources/resources";
import {Injectable} from "@angular/core";
import {Resolve} from "@angular/router";

@Injectable()
export class FormationsAdminResolver implements Resolve<Array<FormationDto>> {

  constructor(private formationWebService: IFormationWebServiceClient) {
  }

  resolve() {
    let critere = new FormationSearchCriteria();
    return this.formationWebService.searchFormations(critere); // getFormations()
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-catalogue-formation/digicerba-catalogue-formation-web/src/angular/cerba/src/app/pages/cerba/pages/administration/formation/admin.formation.resolver.ts